<div class="top-nav-bar" [class.hide-all-but-search-and-title]="shouldHideEverythingButSearchAndTitle" ui-row uiAlign="middle">
  <div class="top-nav-bar__toggle-nav border-right" *ngIf="!isNavExpanded" ui-col>
    <toggle-nav [isNextIcon]="true" uiId="top-subnav-toggle" action="expand"></toggle-nav>
  </div>
  <div class="top-nav-bar__header-container" [class.top-nav-bar__title-container--pl-8]="!isNavExpanded" ui-col ui-row uiAlign="middle">
    <div class="top-nav-bar__title-container" data-test-id="page-title">
      <ng-container *ngIf="navSubTitle">
        <a class="top-nav-bar__subtitle" (click)="actionHandler()" ui-col>{{ navSubTitle.text }}</a>
        <span class="top-nav-bar__title-divider">/</span>
      </ng-container>
      <span class="top-nav-bar__title" [class.truncate-title]="shouldHideEverythingButSearchAndTitle" ui-col>
        <ng-container *uiStringTemplateOutlet="navTitle">{{ navTitle }}</ng-container>
      </span>
    </div>
    <div class="top-nav-bar__favorite" *ngIf="showFavIcon" ui-col>
      <ng-content select="[top-nav-bar-favorite]"></ng-content>
    </div>
    <div class="top-nav-bar__dropdown" *ngIf="showDropdown" ui-col>
      <ng-content select="[top-nav-bar-dropdown]"></ng-content>
    </div>
    <div class="top-nav-bar__tabs-container" *ngIf="showTabs">
      <ng-content select="[top-nav-bar-tabs]"></ng-content>
    </div>
  </div>
  <div class="top-nav-bar__right-content sp-mr-24" ui-col ui-row uiJustify="end" uiAlign="middle">
    <ng-container *ngIf="showButtons">
      <div class="top-nav-bar__buttons-container" *ngIf="buttonsRelaxedMode" ui-col>
        <ng-content select="[top-nav-bar-button-relaxed]"></ng-content>
      </div>
      <div class="top-nav-bar__buttons-container" *ngIf="!buttonsRelaxedMode" ui-col>
        <ng-content select="[top-nav-bar-button-compact]"></ng-content>
      </div>
    </ng-container>
    <ng-container *ngIf="!hideGlobalSearch">
      <global-search [facet]="searchFacet" (globalSearchToggle)="onGlobalSearchToggle($event)" ui-col> </global-search>
    </ng-container>
  </div>
</div>
<ui-divider class="sp-mb-0 sp-mt-0"></ui-divider>
